import React, { useState, useCallback, useEffect } from 'react'
import styled from 'styled-components'
import { BigNumber } from 'bignumber.js'

// utils
import Status from './Status'
import Player from './Player'
import APlayer from './APlayer'
import ImageBig from '../../pages/BakeryArtworks/components/ImageBig'

// components
import Row from '../Row'
// import FlagStatus from '../nftInfo/FlagStatus'

// hooks
import useModal from '../../hooks/bakery/useModal'
// import useUserBids from '../../hooks/nft/useUserBids'
// import { useActiveWeb3React } from '../../hooks'
// import { useMarketLevel } from '../../state/market/hooks'
import { PET_BASE_URL } from '../../constants/pets'

import { getHelmetInfo } from '../../utils/lib/utils'
import { getWeaponInfo } from '../../sushi/utils'
import { getPetImageUrl, getRandom } from '../../utils/func'
import { supportPetType, PetType, BACKGROUND } from '../../constants/pet'
import { useWeaponNftContract, useHelmetNftContract } from '../../hooks/pets/useContract'

export const InfoImgLabel = styled(Row)`
  position: relative;
  width: 500px;
  height: 500px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: ${({ theme}) => theme.bsBg41};
  box-shadow: ${({ theme}) => theme.boxShadow1};
  /* border: 1px solid ${({ theme }) => theme.bsBorder8}; */
  border-radius: 16px;
  overflow: hidden;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    margin: 0 0 30px;
    width: 100%;
    height: auto;
    min-height: 200px;
    max-width: 361px;
  `}
`
export const InfoImg = styled.img`
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
  /* width: 100%;
  width: 100%;
  max-width: 500px;
  max-height: 500px; */
  /* cursor: pointer; */
  /* border-radius: 16px; */
  &[src=""], &:not([src]) {
    opacity: 0;
  }
`
const Picture = styled.div<{bg: string, bgColor?: string, width?: number; height?: number }>`
  width: 100%;
  flex-grow: 1;
  background-size: cover;
  border-radius: 8px;
  background-image: url(${({ bg }) =>  bg ? bg : 'none'});
  background-color: ${({ bgColor }) => bgColor ? bgColor : ''};
  position: relative;
  width: ${({ width }) => (width ? width : 500)}px;
  height: ${({ height }) => (height ? height : 500)}px;
`

const eggTypeLimit = 3
const emotionsLimit = 5
const hatsLimit = 7
const featuresLen = 4

export default function InfoImgCard ({
  history, artwork, type, bakeBalance, status, canReview, isMyArtwork, tokenName
}: {
  history: any, artwork: any, type: string, bakeBalance: number, status: number, canReview: boolean, isMyArtwork: boolean, tokenName?: string
}) {
  // const level = useMarketLevel()
  // const { account } = useActiveWeb3React()

  const [fileUrl, setFileUrl] = useState('')
  const [eggImg, setEggImg] = useState('')
  const [cardBg, setCardBg] = useState('')
  const weaponNft = useWeaponNftContract()
  const helmetNft = useHelmetNftContract()

  // 处理weapon， pet， egg， combo 图片
  const handleDealPicture = useCallback(async() => {
    let url = artwork.fileUrl
    if (artwork.nftType + '' === 'weapon') {
      const num = +artwork.level - 1
      const weaponImgUrl = '/images/weapons/bunny/' + num + '.svg'
      url = weaponImgUrl
    } else if (artwork.nftType === 'pet') {
      const helmet = artwork.helmet && helmetNft ? await getHelmetInfo(helmetNft, +artwork.helmet) : undefined
      const weapon = artwork.weapon && weaponNft ? await getWeaponInfo(weaponNft, artwork.weapon) : undefined
      const petUrl = getPetImageUrl({
        petType: artwork.petType,
        weaponType: weapon ? weapon.weaponType.toString() : 0,
        weaponLevel: weapon ? weapon.level.toString() : 0,
        helmetType: helmet ? helmet.helmetType.toNumber() + 1 : 0,
        helmetLevel: helmet ? helmet.level.toNumber() : 0
      })
      url = 'https://image.battlepets.finance' + PET_BASE_URL + petUrl
    } else if (artwork.nftType === 'petEgg') {
      const artworkId = artwork.id ? Number(artwork.id) : 0
      const petType = new BigNumber(supportPetType.includes(artwork.petType) ? artwork.petType : PetType.kitten)
        .minus(1)
        .mod(eggTypeLimit)
        .integerValue()
        .toString(2)
      const emotions = new BigNumber(artworkId)
        .mod(emotionsLimit)
        .integerValue()
        .toString(2)
      const hats = new BigNumber(artworkId)
        .mod(hatsLimit)
        .integerValue()
        .toString(2)
      const petTypeBinary = Array.from(Array(featuresLen - petType.length).keys()).map(() => '0').join('') + petType
      const emotionsBinary = Array.from(Array(featuresLen - emotions.length).keys()).map(() => '0').join('') + emotions
      const hatsBinary = Array.from(Array(featuresLen - hats.length).keys()).map(() => '0').join('') + hats
      const eggImageUrl = petTypeBinary + emotionsBinary + hatsBinary + '.svg'
      const eggUrl = '/images/pets/egg_bg.png'
      url = 'https://image.battlepets.finance/api/eggs/mdkeuhvm/' + eggImageUrl
      setEggImg(eggUrl)
      setCardBg(BACKGROUND[Math.floor(getRandom(0, BACKGROUND.length * 10000 - 1) / 10000)])
    } else if (artwork.nftType === 'combo') {
      const dishIcon = artwork.items?.map((s: string | number) => {
        const valBinary = new BigNumber(s)
          .div(100000)
          .integerValue(BigNumber.ROUND_FLOOR)
          .toString(2)
        return valBinary.length < 2 ? '0' + valBinary : valBinary
      })
      .join('') + '.svg'
      url = process.env.REACT_APP_DISH_URL + '/api/set0001/' + dishIcon
    }
    setFileUrl(url)
  }, [artwork])

  useEffect(() => {
    if (['weapon', 'pet', 'petEgg', 'combo'].includes(artwork.nftType + '')) {
      handleDealPicture()
    }
  }, [artwork, handleDealPicture])

  // 获取我的竞价
  // const getBids = useUserBids(type)
  // const emptyBids: any[] = []
  // const [ids, setIds] = useState(emptyBids)
  // const getIds = useCallback(async() => {
  //   const bids = await getBids()
  //   if (bids.length) {
  //     const bidsId = bids.map((d: any) => {
  //       return d[0]
  //     })
  //     setIds(bidsId)
  //   }
  // }, [getBids])

  // useEffect(() => {
  //   if (level === 'v2' && account) {
  //     getIds()
  //   }
  // }, [getBids, getIds, level, account, artwork])

  const [imgView] = useModal(
    <ImageBig url={artwork.fileUrl || fileUrl}></ImageBig>
  )

  return <>
    <InfoImgLabel>
      <Status status={(['weapon', 'pet', 'petEgg', 'combo'].includes(artwork.nftType) ? 1 : artwork.status) || 0} />
      {/* <FlagStatus isMyArtwork={isMyArtwork} artwork={artwork} ids={ids}></FlagStatus> */}
      <Picture 
        bg={eggImg} 
        bgColor={cardBg}
      >
        {
          artwork.fileType === 3 ? (
            artwork.fileUrl ? <Player history={history} player={artwork} isMyArtwork={isMyArtwork} status={status} canReview={canReview} type={type} size="true" tokenName={tokenName}></Player> : ''
          ) : artwork.fileType === 4 ? (
            <APlayer history={history} player={artwork} isMyArtwork={isMyArtwork} status={status} canReview={canReview} type={type} size="true" tokenName={tokenName}></APlayer>
          ) : (
            <InfoImg src={artwork.fileUrl || fileUrl} alt="" onClick={imgView}></InfoImg>
          )
        }
      </Picture>
    </InfoImgLabel>
  </>
}
